import React, {Fragment, useEffect, useState} from 'react';
import { useParams, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { addToCart } from "../../store/actions/cartActions";
import Product from './product'
import { getProductBySlug } from "../../api/backend";
import Footer from '../../components/footer/Footer';
import logo from '../../images/gattomioNero.png';


const ProductSinglePage = () => {
    const { slug } = useParams()
    const dispatch = useDispatch();

    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [productLoading, setProductLoading] = useState(true);
    const [productError, setProductError] = useState(null);

    // Carica prodotto dal backend
    useEffect(() => {
        const fetchProduct = async () => {
            setProductLoading(true);
            setProductError(null);

            try {
                const productData = await getProductBySlug(slug);
                
                // Mappatura campi database -> campi componente
                const mappedProduct = {
                    ...productData,
                    title: productData.name,
                    proImg: productData.proImg,
                    delPrice: productData.price,
                    price: productData.sale_price || productData.price
                };
                
                setItem(mappedProduct);
            } catch (error) {
                console.error('Errore caricamento prodotto:', error);
                setProductError(error.message || 'Errore durante il caricamento del prodotto');
                toast.error('Impossibile caricare il prodotto');
            } finally {
                setProductLoading(false);
            }
        };

        if (slug) {
            fetchProduct();
        }
    }, [slug]);

    const handleAddToCart = async (product, qty = 1) => {
        // Verifica che il prodotto abbia un ID
        if (!product.id) {
            toast.error('Prodotto non valido');
            return;
        }

        setLoading(true);

        try {
            await dispatch(addToCart(product.id, qty));
            toast.success(`${product.title} aggiunto al carrello!`);
        } catch (error) {
            console.error('Errore aggiunta al carrello:', error);
            toast.error(error.message || 'Errore durante l\'aggiunta al carrello');
        } finally {
            setLoading(false);
        }
    };

    return(
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={logo} />
            <PageTitle pageTitle={item?.title || 'Product Single'} pagesub={<><Link to="/shop">Shop</Link> > {item?.title}</>}/>
            <section className="wpo-shop-single-section section-padding pb-200">
                <div className="container">
                    {productLoading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Caricamento...</span>
                            </div>
                            <p className="mt-3">Caricamento prodotto...</p>
                        </div>
                    ) : productError ? (
                        <div className="alert alert-danger text-center" role="alert">
                            <h4 className="alert-heading">Errore</h4>
                            <p>{productError}</p>
                            <button
                                className="btn btn-primary mt-3"
                                onClick={() => window.location.reload()}
                            >
                                Riprova
                            </button>
                        </div>
                    ) : !item ? (
                        <div className="alert alert-warning text-center" role="alert">
                            <h4>Prodotto non trovato</h4>
                            <p>Il prodotto che stai cercando non esiste</p>
                            <a href="/shop" className="btn btn-primary mt-3">
                                Torna allo Shop
                            </a>
                        </div>
                    ) : (
                        <Product
                            item={item}
                            addToCart={handleAddToCart}
                            loading={loading}
                        />
                    )}
                </div>
            </section>
            <Footer />
            <Scrollbar/>
        </Fragment>
    )
};

export default ProductSinglePage;
